import { createRoute } from "@tanstack/react-router";

import { ProtectedRoute } from "../auth/ProtectedRoute";
import { DailyReviewContent } from "../components/screens/DailyReviewContent";
import { rootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/daily-review",
  component: DailyReviewRoute,
});

function DailyReviewRoute() {
  return (
    <ProtectedRoute requiredRoles={["owner", "gm"]}>
      <DailyReviewContent />
    </ProtectedRoute>
  );
}
